import { render, staticRenderFns } from "./KgjtWebsiteNewsEdit.vue?vue&type=template&id=aad98fc2&scoped=true&"
import script from "./KgjtWebsiteNewsEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteNewsEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteNewsEdit.vue?vue&type=style&index=0&id=aad98fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad98fc2",
  null
  
)

export default component.exports